/**
 * VSNR (Versicherungsscheinnummer) Validation and Formatting
 * Based on customer-provided validation script
 * 
 * This module validates and formats various VSNR formats used by DOMCURA
 */

// Pattern map for VSNR validation and formatting
// Key: Regex pattern, Value: Replacement pattern with separators
const patternMap: Record<string, string> = {
  "(DCPPDF)(04)(EDE)(1\\d8\\d{3})(3\\d{4})(NG\\d)": "$1-$2-$3-$4-$5-$6",
  "(CCC)(0000\\d{5})(S1)(3\\d{4})(\\d{5})": "$1-$2-$3-$4-$5",
  "(DCC)(SE)(301)(\\d{6})(3\\d{4})(\\d{5})": "$1-$2-$3-$4-$5-$6",
  "(IDCPT)(\\d{2})(\\d{7})(\\d{5})(\\d{5})": "$1-$2-$3-$4-$5",
  "(IDCPT)(04)(1\\d{6})(3\\d{4})(NG0\\d)": "$1-$2-$3-$4-$5",
  "(100)(CCC)(\\d{6})(\\d{5})(\\d{5})": "$1/$2/$3-$4-$5",
  "(100)(DOM)(\\d{6})(3\\d{4})(\\d{5})": "$1/$2/$3-$4-$5",
  "(DCPPDF)(\\d{2})(EAP)(1\\d{5})(\\d{5})": "$1-$2-$3-$4-$5",
  "(DCPPDF)(\\d{2})(EDE)(1\\d{5})(\\d{5})": "$1-$2-$3-$4-$5",
  "(HV)(SV7\\d{7})(\\d)(00\\d{3})(802\\d)": "$1-$2.$3-$4-$5",
  "(IDCPT)(\\d4)(\\d{7})(\\d{5})(NG\\d)": "$1-$2-$3-$4-$5",
  "(100)(AD)(0\\d{5})(3\\d{4})(3\\d{4})": "$1/$2/$3-$4-$5",
  "(CCC)(3\\d{5})(B1)(3\\d{4})(\\d{5})": "$1-$2-$3-$4-$5",
  "(DCPPDF)(\\d{2})(EAP)(\\d{5})(\\d{5})": "$1-$2-$3-$4-$5",
  "(DCPPDF)(\\d{2})(EDE)(\\d{5})(\\d{5})": "$1-$2-$3-$4-$5",
  "(IDCPT)(\\d4)(\\d{7})(\\d{5})(NG)": "$1-$2-$3-$4-$5",
  "(100)(DOM)(1\\d{5})(\\d{5})(1)(2)(1)": "$1/$2/$3-$4-$5-$6-$7",
  "(DCDO)(\\d4)(\\d{7})(\\d{5})(NG)": "$1-$2-$3-$4-$5",
  "(DCPPDF)(\\d{2})(\\d{7})(\\d{5})": "$1-$2-$3-$4",
  "(HV)(SV7\\d{7})(\\d)(892)(8020)": "$1-$2.$3-$4-$5",
  "(100)(CCC)(0\\d{5})(3\\d{4})(NG)": "$1/$2/$3-$4-$5",
  "(\\d{2}A)(531)(\\d{9})(\\d)(\\d{3})": "$1-$2-$3-$4/$5",
  "(CCC)(0000\\d{5})(S1)(\\d{5})": "$1-$2-$3-$4",
  "(DCC)(SE)(301)(\\d{6})(\\d{5})": "$1-$2-$3-$4-$5",
  "(DCPPDF)(04)(EAP)(1\\d{5})(NG)": "$1-$2-$3-$4-$5",
  "(DCPPDF)(04)(EDE)(1\\d{5})(NG)": "$1-$2-$3-$4-$5",
  "(DOM)(SE)(301)(\\d{6})(\\d{5})": "$1-$2-$3-$4-$5",
  "(GHV\\d0)(0\\d{3})(\\d{7})(\\d{3})": "$1/$2/$3/$4",
  "(GSV30)(0220)(\\d{7})(490)": "$1/$2/$3/$4",
  "(HV)(HA\\d{7})(\\d)(892)(8020)": "$1-$2.$3-$4-$5",
  "(IDCPT)(\\d{2})(\\d{7})(\\d{5})": "$1-$2-$3-$4",
  "(100)(AMEX)(00\\d{4})(\\d{5})": "$1/$2/$3-$4",
  "(100)(CCC)(\\d{7})(\\d{5})": "$1/$2/$3-$4",
  "(100)(DCFF)(00\\d{4})(\\d{5})": "$1/$2/$3-$4",
  "(DCDO)(\\d{2})(\\d{7})(\\d{5})": "$1-$2-$3-$4",
  "(DCPPDF)(04)(1\\d{6})(NG\\d)": "$1-$2-$3-$4",
  "(DCPPDF)(04)(EAP)(\\d{5})(NG)": "$1-$2-$3-$4-$5",
  "(DCPPDF)(04)(EDE)(\\d{5})(NG)": "$1-$2-$3-$4-$5",
  "(DCPT)(\\d{2})(00\\d{5})(\\d{5})": "$1-$2-$3-$4",
  "(HV)(SV7\\d{7})(\\d)(00892)": "$1-$2.$3-$4",
  "(IDCPT)(\\d4)(\\d{7})(NG0\\d)": "$1-$2-$3-$4",
  "(IDCPT)(\\d4)(00\\d{5})(NG)(II)": "$1-$2-$3-$4 $5",
  "(\\d{3})(2\\d)(\\d{9}2\\d{2})": "$1/$2/$3",
  "(100)(CCC)(\\d{6})(\\d{5})": "$1/$2/$3-$4",
  "(100)(DOM)(\\d{6})(\\d{5})": "$1/$2/$3-$4",
  "(DCDO)(04)(1\\d{6})(NG0\\d)": "$1-$2-$3-$4",
  "(DCPPDF)(\\d4)(\\d{7})(NG)": "$1-$2-$3-$4",
  "(DCPPDF)(\\d{2})(EAP)(1\\d{5})": "$1-$2-$3-$4",
  "(DCPPDF)(\\d{2})(EDE)(1\\d{5})": "$1-$2-$3-$4",
  "(DFV)(0000001\\d{7})": "$1-$2",
  "(DOM)(S)(\\d{3})(\\d{5})(\\d{5})": "$1-$2-$3-$4-$5",
  "(IDCPT)(79)(0\\d{6})(\\d)(\\d)(1)": "$1-$2-$3-$4-$5-$6",
  "(IDCPT)(\\d4)(\\d{7})(NG\\d)": "$1-$2-$3-$4",
  "(IDCPT)(\\d4)(\\d{7})(NG)(I)": "$1-$2-$3-$4 $5",
  "(\\d{4})(\\d{2})(\\d{3})(0\\d)(0\\d)(\\d{2})(\\d)": "$1.$2.$3.$4.$5.$6.$7",
  "(100)(AD)(0\\d{5})(\\d{5})": "$1/$2/$3-$4",
  "(100)(AR)(0\\d{5})(\\d{5})": "$1/$2/$3-$4",
  "(CCC)(3\\d{5})(B1)(\\d{5})": "$1-$2-$3-$4",
  "(DCDO)(\\d4)(\\d{7})(NG\\d)": "$1-$2-$3-$4",
  "(DCPPDF)(\\d{2})(EAP)(\\d{5})": "$1-$2-$3-$4",
  "(DCPPDF)(\\d{2})(EDE)(\\d{5})": "$1-$2-$3-$4",
  "(H\\d{4})(60000)(000)(NG\\d)": "$1.$2.$3-$4",
  "(IDCPT)(\\d{2})(\\d{7})(NG)": "$1-$2-$3-$4",
  "(\\d{2})(\\d{3}0\\d)(\\d{8})": "$1/$2/$3",
  "(40\\d)(\\d{2})(\\d{9})(J)": "$1 $2 $3 $4",
  "(0041)(07)(366)(709)(H)(\\d{2})": "$1/$2 $3 $4 $5 $6",
  "(100)(AMEX)(00\\d{4})(NG)": "$1/$2/$3-$4",
  "(100)(DCFF)(0\\d{5})(NG)": "$1/$2/$3-$4",
  "(100)(DOM)(\\d{6})(\\d)(\\d)(1)": "$1/$2/$3-$4-$5-$6",
  "(100)(DOM)(\\d{6})(NG\\d)": "$1/$2/$3-$4",
  "(90)(POLI)(\\d{6})(\\d)(\\d)(\\d)": "$1-$2-$3-$4-$5-$6",
  "(90)(POLI)(\\d{6})(NG\\d)": "$1-$2-$3-$4",
  "(DCDO)(\\d4)(\\d{7})(NG)": "$1-$2-$3-$4",
  "(DCPPDF)(\\d{2})(\\d{7})": "$1-$2-$3",
  "(DCPT)(04)(00\\d{5})(NG)": "$1-$2-$3-$4",
  "(INNO)(\\d4)(\\d{7})(NG)": "$1-$2-$3-$4",
  "(INNO)(\\d4)(00\\d{4})(M)(NG)": "$1-$2-$3-$4-$5",
  "(POLI)(0000000\\d{2}S4)": "$1-$2",
  "(4\\d{2})(\\d{2})(\\d{9})": "$1 $2 $3",
  "(100)(AR)(0\\d{5})(NG\\d)": "$1/$2/$3-$4",
  "(100)(CCC)(0\\d{5})(NG)": "$1/$2/$3-$4",
  "(100)(DOM)(\\d{6})(NG)": "$1/$2/$3-$4",
  "(90)(POLI)(0\\d{5})(\\d{2})": "$1-$2-$3-$4",
  "(90)(POLI)(1\\d{5}AS)": "$1-$2-$3",
  "(90)(POLI)(\\d{6})(NG)": "$1-$2-$3-$4",
  "(AFA)(SE)(30\\d)(\\d{6})": "$1-$2-$3-$4",
  "(CCC)(000000\\d{3})(I2)": "$1-$2-$3",
  "(CCC)(0000\\d{5})(S1)": "$1-$2-$3",
  "(CUL)(00\\d{4})(43182)": "$1-$2-$3",
  "(DCC)(SE)(301)(\\d{6})": "$1-$2-$3-$4",
  "(DCP)(\\d5)(EAP)(1\\d{5})": "$1-$2-$3-$4",
  "(DCSDK)(\\d{2})(1001\\d{3})": "$1-$2-$3",
  "(DOM)(SE)(301)(\\d{6})": "$1-$2-$3-$4",
  "(IDCPT)(\\d{2})(\\d{7})": "$1-$2-$3",
  "(INNO)(\\d{2})(1\\d{7})": "$1-$2-$3",
  "(INV)(SE)(301)(2\\d{5})": "$1-$2-$3-$4",
  "(KS)(04)(\\d{7})(NG\\d)": "$1-$2-$3-$4",
  "(\\d{2})(0\\d{3})(\\d{7})": "$1/$2/$3",
  "(100)(AD)(0\\d{5})(NG)": "$1/$2/$3-$4",
  "(100)(AMEX)(\\d{6})": "$1/$2/$3",
  "(100)(AR)(0\\d{5})(NG)": "$1/$2/$3-$4",
  "(100)(CCC)(\\d{7})": "$1/$2/$3",
  "(\\d{3})(DCFF)(\\d{6})": "$1/$2/$3",
  "(100)(DOM)(\\d{7})": "$1/$2/$3",
  "(100)(FOC)(\\d00\\d{4})": "$1/$2/$3",
  "(90)(POLI)(\\d{7})": "$1-$2-$3",
  "(AH)(02)(00\\d{7})": "$1-$2-$3",
  "(AK)(\\d{2})(001\\d{6})": "$1-$2-$3",
  "(DCDO)(\\d{2})(\\d{7})": "$1-$2-$3",
  "(DCP)(\\d5)(EAP)(\\d{5})": "$1-$2-$3-$4",
  "(DCPT)(\\d{2})(00\\d{5})": "$1-$2-$3",
  "(H\\d{4})(\\d0000)(\\d{3})": "$1.$2.$3",
  "(H\\d{4})(600UH)(\\d{3})": "$1.$2.$3",
  "(INNO)(\\d{2})(\\d{7})": "$1-$2-$3",
  "(INNO)(\\d{2})(\\d{6})(M)": "$1-$2-$3-$4",
  "(KS)(04)(\\d{7})(NG)": "$1-$2-$3-$4",
  "(L\\d{9}012)": "$1",
  "(MMP9500022\\d{3})": "$1",
  "(SV75\\d{6})(892)": "$1-$2",
  "(T1\\d{3})(60000)(BHV)": "$1.$2.$3",
  "(ass)(\\d{3})(\\d{7})": "$1-$2-$3",
  "(6\\d{6})(\\d)(0000)": "$1-$2-$3",
  "(\\d{4})(\\d0000)(BHV)": "$1.$2.$3",
  "(100)(BES)(000\\d{3})": "$1/$2/$3",
  "(100)(CCC)(\\d{6})": "$1/$2/$3",
  "(100)(DCFF)(\\d{5})": "$1/$2/$3",
  "(100)(DOL)(000\\d{3})": "$1/$2/$3",
  "(100)(DOM)(\\d{6})": "$1/$2/$3",
  "(100)(FOC)(000\\d{3})": "$1/$2/$3",
  "(02)(BHV)(1\\d{6})": "$1-$2-$3",
  "(90)(POLI)(\\d{6})": "$1-$2-$3",
  "(AFA)(S)(301)(\\d{5})": "$1-$2-$3-$4",
  "(AS)(\\d{10})": "$1-$2",
  "(BA)(\\d{3})(\\d{7})": "$1-$2-$3",
  "(DOM)(O)(\\d{3})(\\d{5})": "$1-$2-$3-$4",
  "(DOM)(O)(EFH)(01\\d{3})": "$1-$2-$3-$4",
  "(DOM)(S)(\\d{3})(\\d{5})": "$1-$2-$3-$4",
  "(H\\d{3})(\\d0000)(000)": "$1.$2.$3",
  "(H\\d{3})(600UH)(0\\d{2})": "$1.$2.$3",
  "(INNO)(\\d{2})(\\d{6})": "$1-$2-$3",
  "(INV)(I)(301)(\\d{5})": "$1-$2-$3-$4",
  "(INV)(S)(301)(\\d{5})": "$1-$2-$3-$4",
  "(POLI)(50\\d{4})(\\d{2})": "$1-$2-$3",
  "(POLI)(\\d{4})(S5)(\\d{2})": "$1-$2-$3-$4",
  "(T1\\d{3})(60000)(RS)": "$1.$2.$3",
  "(T\\d{3})(60000)(BHV)": "$1.$2.$3",
  "(Y)(22)(05\\d{6})(\\d)": "$1-$2-$3-$4",
  "(ass)(\\d{2}1)(0\\d{5})": "$1-$2-$3",
  "(\\d{11})": "$1",
  "(\\d{4})(60000)(RS)": "$1.$2.$3",
  "(100)(AD)(0\\d{5})": "$1/$2/$3",
  "(100)(AR)(\\d{6})": "$1/$2/$3",
  "(100)(CCC)(\\d{5})": "$1/$2/$3",
  "(100)(DOM)(\\d{5})": "$1/$2/$3",
  "(100)(FF)(00\\d{4})": "$1/$2/$3",
  "(02)(BHV)(00\\d{4})": "$1-$2-$3",
  "(90)(POI)(0\\d{5})": "$1-$2-$3",
  "(90)(POLI)(\\d{5})": "$1-$2-$3",
  "(06)(SI)(1\\d{6})": "$1-$2-$3",
  "(AH)(02)(1\\d{6})": "$1-$2-$3",
  "(AK)(\\d{2})(\\d{7})": "$1-$2-$3",
  "(BA)(2\\d1)(00\\d{4})": "$1-$2-$3",
  "(CCC)(3\\d{5})(B1)": "$1-$2-$3",
  "(INNO)(1\\d{6})": "$1-$2",
  "(INV)(0\\d{5})(NG)": "$1-$2-$3",
  "(K)(\\d{3})(\\d{6})(\\d)": "$1 $2-$3/$4",
  "(KS)(\\d{2})(\\d{7})": "$1-$2-$3",
  "(POLI)(\\d{3})(S5)(\\d{2})": "$1-$2-$3-$4",
  "(V)(0\\d{2})(\\d{3})(\\d{3})(\\d)": "$1-$2-$3-$4-$5",
  "(\\d{10})": "$1",
  "(06)(SI)(00\\d{4})": "$1-$2-$3",
  "(A2005)(0\\d{4})": "$1-$2",
  "(INV)(\\d{7})": "$1-$2",
  "(POLI)(\\d{6})": "$1-$2",
  "(POLI)(\\d{4})(S5)": "$1-$2-$3",
  "(POLI)(\\d{2})(S5)(03)": "$1-$2-$3-$4",
  "(\\d{9})": "$1",
  "(ASG)(\\d{6})": "$1-$2",
  "(AWD)(00\\d{4})": "$1-$2",
  "(BA)(2\\d1)(1\\d{3})": "$1-$2-$3",
  "(COM)(00\\d{4})": "$1-$2",
  "(CUL)(00\\d{4})": "$1-$2",
  "(FAZ)(00\\d{4})": "$1-$2",
  "(FIN)(00\\d{4})": "$1-$2",
  "(FSP)(0\\d{5})": "$1-$2",
  "(HOR)(00\\d{4})": "$1-$2",
  "(INV)(0\\d{5})": "$1-$2",
  "(POLI)(\\d{3})(S5)": "$1-$2-$3",
  "(SEC)(00\\d{4})": "$1-$2",
  "(SIS)(00\\d{4})": "$1-$2",
  "(SPS)(000\\d{3})": "$1-$2",
  "(VVO)(\\d{6})": "$1-$2",
  "(WPS)(00\\d{4})": "$1-$2",
  "(WSH)(000\\d{3})": "$1-$2",
  "(\\d{8})": "$1",
  "(POLI)(\\d{2})(S5)": "$1-$2-$3",
  "(\\d{7})": "$1",
  "(KS)(02)(1\\d)": "$1-$2-$3"
};

// Simplified issue map for text input (no voice/phonetic corrections needed)
// Only includes common typo corrections and prefix fixes
const issueMap: Record<string, string> = {
  // Common prefix corrections
  " BCDO ": "DCDO",
  " BCC ": "CCC",
  " BCPPDF ": "DCPPDF",
  " BCPT ": "IDCPT",
  " BOM ": "DOM",
  " CDO ": "DCDO",
  " CPPDF ": "DCPPDF",
  " DCD ": "DCDO",
  " DCDU ": "DCDO",
  " DCPDF ": "DCPPDF",
  " DCPPDS ": "DCPPDF",
  " DCPPWF ": "DCPPDF",
  " DCPT ": "IDCPT",
  " DCTPDF ": "DCPPDF",
  " DCTO ": "DCDO",
  " DNV ": "INV",
  " DOMM ": "DOM",
  " DOMO ": "DOM",
  " DON ": "DOM",
  " DORM ": "DOM",
  " DUM ": "DOM",
  " EDCPT ": "IDCPT",
  " ENNO ": "INNO",
  " ENV ": "INV",
  " GOM ": "DOM",
  " ICPT ": "IDCPT",
  " IDCP ": "IDCPT",
  " IDCPP ": "IDCPT",
  " IDCT ": "IDCPT",
  " IDCTT ": "IDCPT",
  " IMMO ": "INNO",
  " INNU ": "INNO",
  " INO ": "INNO",
  " MMO ": "INNO",
  " NNO ": "INNO",
  " PCC ": "CCC",
  " PCPPDF ": "DCPPDF",
  " POLY ": "POLI",
  " POLLY ": "POLI",
};

/**
 * Check if input matches any known VSNR pattern and format it
 */
function checkOutputPattern(input: string): string {
  // Try removing up to 5 trailing non-digit characters
  for (let i = 0; i <= 5; i++) {
    let testInput = input;
    if (i > 0) {
      // Only remove if last char is not a digit
      if (!isNaN(parseInt(input.slice(-1)))) {
        continue;
      }
      testInput = input.slice(0, -i);
    }
    
    for (const [pattern, replacement] of Object.entries(patternMap)) {
      const regex = new RegExp(`^${pattern}$`, "i");
      const match = testInput.match(regex);
      
      if (match && match[0] === testInput) {
        const formatted = testInput.replace(regex, replacement);
        return formatted.toUpperCase();
      }
    }
  }
  
  return "";
}

/**
 * Validate and format a VSNR input
 * @param input - The raw VSNR input string
 * @returns Formatted VSNR string or null if invalid
 */
export function validateAndFormatVSNR(input: string): string | null {
  if (!input || input.trim().length < 5) {
    return null;
  }

  // Remove all special characters except alphanumeric
  let cleaned = input.replace(/[^a-zA-Z0-9]/g, '');
  
  // Add spaces at start and end for issue map matching
  cleaned = ' ' + cleaned.toUpperCase() + ' ';
  
  // Insert space between letters and numbers for pattern matching
  cleaned = cleaned.replace(/([a-zA-Z])(\d)/g, '$1 $2');
  cleaned = cleaned.replace(/(\d)([a-zA-Z])/g, '$1 $2');
  
  // Apply issue map corrections
  for (const [src, target] of Object.entries(issueMap)) {
    cleaned = cleaned.replace(new RegExp(src, "ig"), target);
  }
  
  // Remove all spaces for final pattern matching
  cleaned = cleaned.replace(/\s/g, '');
  
  // Check against patterns
  const result = checkOutputPattern(cleaned);
  
  return result || null;
}

/**
 * Check if a VSNR input is valid (matches any known pattern)
 * @param input - The VSNR input string
 * @returns true if valid, false otherwise
 */
export function isValidVSNR(input: string): boolean {
  return validateAndFormatVSNR(input) !== null;
}

/**
 * Get validation status with helpful message
 * @param input - The VSNR input string
 * @returns Object with isValid flag and message
 */
export function getVSNRValidationStatus(input: string): { 
  isValid: boolean; 
  formatted: string | null; 
  message: string;
} {
  if (!input || input.trim().length === 0) {
    return {
      isValid: false,
      formatted: null,
      message: ""
    };
  }
  
  if (input.trim().length < 5) {
    return {
      isValid: false,
      formatted: null,
      message: "VSNR ist zu kurz"
    };
  }
  
  const formatted = validateAndFormatVSNR(input);
  
  if (formatted) {
    return {
      isValid: true,
      formatted,
      message: ""
    };
  }
  
  return {
    isValid: false,
    formatted: null,
    message: "Ungültiges VSNR-Format"
  };
}
